import * as Type from './actionsTypes';

const INITIAL_STATE = {
  odometros: [],
  selectedOdometro: null,
  options: [],
};

const ordernarData = (a, b) => {
  const dataDiff = Number(b.data) - Number(a.data);
  if (dataDiff !== 0) return dataDiff;
  const placaDiff = (a.veiculoPlaca || '').localeCompare(b.veiculoPlaca || '');
  if (placaDiff !== 0) return placaDiff;
  return (a.odometroInicial || 0) - (b.odometroInicial || 0);
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.FETCH_ODOMETROS_SUCCESS: {
      return {
        ...state,
        odometros: action.data.sort(ordernarData)
      }
    }
    case Type.DELETE_ODOMETRO_SUCCESS: {
      return {
        ...state,
        odometros: state.odometros.filter(s => s.id !== action.data).sort(ordernarData)
      }
    }
    case Type.SAVE_ODOMETRO_SUCCESS: {
      return {
        ...state,
        odometros: [...state.odometros, action.data].sort(ordernarData)
      }
    }
    case Type.UPDATE_ODOMETRO_SUCCESS: {
      return {
        ...state,
        odometros: [...state.odometros.filter(s => s.id !== action.data.id), action.data].sort(ordernarData)
      }
    }
    case Type.ODOMETRO_FIND_BY_ID_SUCCESS: {
      return {
        ...state,
        selectedOdometro: action.data
      }
    }
    case Type.ODOMETRO_VALIDATE_BY_ID_SUCCESS: {
      return {
        ...state,
        odometros: state.odometros.map(s =>
          s.id === action.id ? { ...s, validate: action.validate } : s
        )
      }
    }
    case Type.ODOMETRO_FIND_OPTIONS_SUCCESS: {
      return {
        ...state,
        options: action.data
      }
    }
    case Type.CLEAR_ODOMETRO: {
      return INITIAL_STATE;
    }
    default:
      return state;
  }
}

export const getOdometros = state => state.rootState.odometro.odometros;
export const getSelectedOdometro = state => state.rootState.odometro.selectedOdometro;
export const getOdometrosOptions = state => state.rootState.odometro.options;
